export const activationEmailSendingError = "Une erreur s'est produite. L'invitation n'a pas été envoyée.";
export const activationEmailSendingSuccess = "L'invitation n'a pas été envoyée avec succès.";
export const etablissementCreationConflict = "Il y a déjà un établissement avec ce numéro de SIRET.";
export const apiKeyGeneratedSuccess = "La nouvelle API Key a été générée.";
export const apiKeyGeneratedFailure = "La génération de l'API Key a échoué.";